<template>
	<div class="Download">
		下载
	</div>
</template>

<script>
	export default {
		name: 'Download',
		created() {
			
		},
		methods: {
	
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/Download.vue